/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useState, useEffect } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
// import { toast } from 'react-toastify'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
// import 'react-toastify/dist/ReactToastify.css'
import { chevronLeft, plus } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'
import SingleSelect from '../../../../components/form/SingleSelect'
import Select from "react-select"
import ReactQuill from "react-quill";
import { toast } from 'react-toastify'
import { optionContext } from '../../../../utils/Context/optionContext'
import { Height } from "../../../../components/OptionsData/HeightData/Heightdata";
// ../../OptionsData/HeightData/Heightdata
// import ReactQuill from "react-quill";
const address = require('@bangladeshi/bangladesh-address')
//toast.configure({ autoClose: 2000 })
const Create = () => {
    const navigate = useNavigate()
    const { options, handleOptionToData } = useContext(optionContext)
    const [error, setError] = useState(null)
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [isLoading, setLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [faqs, setFaqs] = useState([]);
    const [newFaq, setNewFaq] = useState({ question: "", answer: "" });
    const [value, setValue] = useState("");
        const handleChange = (content) => {
        setValue(content);
        // console.log(content);
        
        // if (onChange) onChange(content);
    };

    const [profession, setProfession] = useState();
    // const [qualification, setQualification] = useState();
    const [district, setDistrict] = useState();

    const [newProfessionArea, setProfessionArea] = useState({
              value: null,
              options: []
          })
    const [newQualification, setQualification] = useState({
            value: null,
            options: []
        })
    const [newHeight, setHeight] = useState({
            value: null,
            options: Height
        })

    useEffect(() => {
            setQualification({ ...newQualification, options: handleOptionToData("Qualification") })
            // setWorkingWith({ ...newWorkingWith, options: handleOptionToData("Working with") })
            setProfessionArea({ ...newProfessionArea, options: handleOptionToData("Profession area") })
            // setAnnualIncome({ ...annualIncome, options: handleOptionToData("Income") })
        }, [options])
    
    const rawDistict = address.allDistict();
        const all_Distict = rawDistict.map(div => ({
                value: div,
                label: div
            }));

        
        
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    const [items, setItems] = useState([]);
 
    // Handle image
    const handleImage = event => {
        const file = event.target.files[0]
        if (file) {
            const size = parseInt(file.size) / 1000
            if (size > 300) {
                setError({ ...error, image: 'Select less than 300KB file.' })
                return
            }
            setSelectedFile({ image: file, preview: URL.createObjectURL(file) })
            setError({ ...errors, image: null })
        }
    }

    // Submit Form
    const onSubmit = async (data) => {
        try {
            if (!selectedFile) return setError({ ...error, image: 'Image is required' })

            setLoading(true)
            let formData = new FormData()
            formData.append('metaTitle', data.metaTitle)
            formData.append('metaDescription', data.metaDescription)
            formData.append('title', data.title)
            formData.append('subBannerTitle', data.subBannerTitle)
            formData.append('bannerDescription', data.bannerDescription)
            formData.append('district', district)
            formData.append('profession', profession)
            formData.append('description', value)
            formData.append("faq", JSON.stringify(faqs));
            formData.append("profileVerification", JSON.stringify(items));
            formData.append('image', selectedFile.image)

            
            const res = await Requests.ProfilesByProfession.Store(formData, header)
            console.log(res.status);
            
            if (res.status === true) {
                setLoading(false)
                navigate('/dashboard/website/profiles-by-profession')
                toast.success(res.message)
                
            }else{
                setLoading(false)
                 toast.error(res.message || "Something went wrong");
                // navigate('/dashboard/website/profiles-by-profession')
            }
        } catch (error) {
            if (error) console.log(error)
        }
    }

    return (
        <div className="store-story pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Feature Profile</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/website/story"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    {/*  Meta Title */}
                                    {/* <div className="col-12">
                                        <div className="form-group mb-4">
                                            {errors.metaTitle && errors.metaTitle.message ? (
                                                <p className="text-danger">{errors.metaTitle && errors.metaTitle.message}</p>
                                            ) : <p>Meta Title</p>
                                            }

                                            <input
                                                type="text"
                                                name="metaTitle"
                                                className="form-control shadow-none"
                                                placeholder="Enter Meta Title"
                                                {...register("metaTitle", { required: "Title is required" })}
                                            />
                                        </div>
                                    </div> */}

                                    {/* metaDescription */}
                                    {/* <div className="form-group mb-4">
                                        {errors.metaDescription && errors.metaDescription.message ? (
                                            <p className="text-danger">{errors.metaDescription && errors.metaDescription.message}</p>
                                        ) : <p>Meta Description</p>}

                                        <textarea
                                            type="text"
                                            name="metaDescription"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter Meta Description"
                                            {...register("metaDescription", { required: "Description is required" })}
                                        />
                                    </div> */}

                                        <div className="row">

                                        {/* Name */}
                                        <div className="col-12 col-lg-12">
                                            <div className="form-group mb-4">
                                                {errors.name && errors.name.message ? (
                                                    <p className="text-danger">{errors.name && errors.name.message}</p>
                                                ) : <p>Name</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Name"
                                                    {...register("name", { required: "Name is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* Description */}
                                        <div className="section-box border rounded p-4 mb-4 bg-white">
                                            <p className="section-title mb-3">Description</p>

                                            <ReactQuill
                                                value={value}
                                                onChange={handleChange}
                                                theme="snow"
                                                rows={5}
                                                className="bg-white"
                                            />
                                        </div>
                                    </div>

                                    
                                    <div className='row'>
                                        
                                        {/*  District */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.district && errors.district.message ? (
                                                    <p className="text-danger">{errors.district && errors.district.message}</p>
                                                ) : <p>District</p>
                                                }

                                                <Select
                                                    classNamePrefix="custom-select"
                                                    styles={customStyles}
                                                    placeholder={"Select"}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    options={all_Distict}
                                                    // defaultValue={defaultValueHandler(
                                                    //     query.manager,
                                                    //     items
                                                    // )}
                                                    onChange={(event) => setDistrict(event.value)}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.district && errors.district.message ? (
                                                    <p className="text-danger">{errors.district && errors.district.message}</p>
                                                ) : <p>Profession</p>
                                                }

                                                <Select
                                                    classNamePrefix="custom-select"
                                                    styles={customStyles}
                                                    placeholder={"Select"}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    options={newProfessionArea.options}
                                                    // options={items}
                                                    // defaultValue={defaultValueHandler(
                                                    //     query.manager,
                                                    //     items
                                                    // )}
                                                    onChange={(event) => setProfession(event.value)}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group mb-4">
                                        <p>College(s) Attended</p>
                                        <input
                                            type="text"
                                            className="form-control shadow-none"
                                            placeholder="your educational institite name"
                                            // defaultValue={institute || ''}
                                            name='institute'
                                            {...register('institute')}
                                        />
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="form-group mb-4">
                                        <p>Qualification</p>
                                        <Select
                                            classNamePrefix="custom-select"
                                            styles={customStyles}
                                            placeholder={"Select"}
                                            components={{
                                                DropdownIndicator: () => null,
                                                IndicatorSeparator: () => null,
                                            }}
                                            options={newQualification.options}
                                            // options={items}
                                            // defaultValue={defaultValueHandler(
                                            //     query.manager,
                                            //     items
                                            // )}
                                            onChange={(event) => setQualification(event.value)}
                                            menuPortalTarget={document.body}
                                        />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="form-group mb-4">
                                        <p>Your Height</p>
                                        <Select
                                            classNamePrefix="custom-select"
                                            styles={customStyles}
                                            placeholder={"Select"}
                                            components={{
                                                DropdownIndicator: () => null,
                                                IndicatorSeparator: () => null,
                                            }}
                                            options={newHeight.options}
                                            // options={items}
                                            // defaultValue={defaultValueHandler(
                                            //     query.manager,
                                            //     items
                                            // )}
                                            onChange={(event) => setHeight(event.value)}
                                            menuPortalTarget={document.body}
                                        />

                                        {/* <SingleSelect
                                            options={newHeight.options}
                                            // data={user.basicAndLifestyleInformation.height || ''}
                                            value={(data) => setHeight({ ...newHeight, value: data })}
                                        /> */}
                                    </div>
                                    </div>                                       
                                    </div>


                                    {/* Image upload Container */}
                                    <div className="form-group mb-4">
                                        {error && error.image ? <p className="text-danger">{error.image}</p> : <p>Image</p>}
                                        <div className="d-flex">
                                            {selectedFile && selectedFile.preview ?
                                                <div className="img-container text-center mr-2">
                                                    <div className="image border">
                                                        <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                                    </div>
                                                </div>
                                                : null}

                                            <div className="img-container text-center">
                                                <div className="image border">
                                                    <input type="file" className="upload" onChange={handleImage} />
                                                    <div className="flex-center flex-column">
                                                        <Icon icon={plus} size={22} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Image upload Container */}
                                    {/* <div className="form-group mb-4">
                                        {error && error.image ? <p className="text-danger">{error.image}</p> : <p>Gallery Images</p>}
                                        <div className="d-flex">
                                            {selectedFile && selectedFile.preview ?
                                                <div className="img-container text-center mr-2">
                                                    <div className="image border">
                                                        <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                                    </div>
                                                </div>
                                                : null}

                                            <div className="img-container text-center">
                                                <div className="image border">
                                                    <input type="file" className="upload" onChange={handleImage} />
                                                    <div className="flex-center flex-column">
                                                        <Icon icon={plus} size={22} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className="text-end">
                                        <button type="submit" className="btn shadow-none" disabled={isLoading}>
                                            {isLoading ? 'Creating...' : 'Create'}
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Create;
const customStyles = {
    control: (provided, state) => ({
        ...provided,
        height: 40,
        fontSize: 13,
        color: "#000",
        minWidth: 170,
        boxShadow: "none",
        "&:hover": { borderColor: "1px solid #ced4da" },
        border: state.isFocused ? "1px solid #dfdfdf" : "1px solid #ced4da",
        borderRadius: 0,
        menuPortal: base => ({ ...base, zIndex: 999 })
    }),
};